import { Container, Grid, Typography } from "@mui/material";
import ScreenBanner from "../../../../../components/ScreenBanner";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../../../../components/ListaAcoesRapidas";
import ProximosFechamentos from "./ProximosFechamentos";
import UltimosFechamentos from "./UltimosFechamentos";
import SettingsIcon from '@mui/icons-material/Settings';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useState } from "react";
import DialogIncluirLancamento from "../DialogIncluirLancamento";
import { useNavigate } from "react-router-dom";
import PermissionGuard, { usePermission } from "../../../../../components/PermissionGuard";

export default function VisaoGeral() {
    const navigate = useNavigate();

    const [openIncluirLancamento, setOpenIncluirLancamento] = useState(false)

    //valores importantes
    const listaAcoesRapidas: TItemAcaoRapida[] = [
        {
            label: "Incluir lançamento",
            icon: <AddCircleOutlineIcon color="primary" />,
            action: () => setOpenIncluirLancamento(true),
            havePermission: usePermission("financeiro.cco-incluir-lancamento")
        },
        {
            label: "Configurações",
            icon: <SettingsIcon color="primary" />,
            action: () => navigate("/financeiro/configuracoes?menu=Conta%20consumo"),
            havePermission: usePermission("financeiro.configuracoes.conta-corrente")
        }
    ]
    //

    return (
        <>
            <ScreenBanner title="Financeiro" />
            <PermissionGuard permissionId="financeiro.cco-visualizar">
                <Container sx={{ mt: 3 }}>
                    <Typography textAlign="center" variant="h5" mb={2}>Conta consumo</Typography>

                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 3}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                                fullHeight={false}
                            />
                        </Grid>

                        <Grid container size={{xs: 12, md: 9}} spacing={2}>
                            <Grid size={{xs: 12}}>
                                <ProximosFechamentos />
                            </Grid>

                            <Grid size={{xs: 12}}>
                                <UltimosFechamentos />
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
                {
                    openIncluirLancamento &&
                    <DialogIncluirLancamento
                        open={openIncluirLancamento}
                        handleClose={() => setOpenIncluirLancamento(false)}
                    />
                }
            </PermissionGuard>
        </>
    )
}